import { type ThemeOptions } from '@material-ui/core';

/** @deprecated no mui usages */
export const darkModeTheme: ThemeOptions = {
  palette: {
    type: 'dark',
  },
};
